import { commitMutation } from 'react-relay';
import type { Environment } from 'react-relay';
import type {
    MutationConfig,
    MutationParameters,
} from 'relay-runtime/lib/mutations/commitMutation';

/**
 *
 * @param {Environment} environment
 * @param {Object} config
 * @returns {Promise<Object>}
 */
export default function commitMutationPromise<
    TOperation extends MutationParameters,
>(
    environment: Environment,
    config: MutationConfig<TOperation>,
): Promise<TOperation['response']> {
    return new Promise((resolve, reject) =>
        commitMutation<TOperation>(environment, {
            ...config,
            onCompleted: (payload, errors) =>
                errors ? reject(errors[0]) : resolve(payload),
            onError: reject,
        }),
    );
}
